// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../../../elements/CustomModal/CustomModal';
import {colors} from '../../../assets/styles/colors';
import NewFeatureBadge from '../../../elements/NewFeatureBadge/NewFeatureBadge';
import quickOrderStateChangeTutorial from '../../../assets/img/quickOrderStateChangeTutorial.svg';
import {useIsFeatureInTier} from '../../../utils/component';
import PremiumFeatureBadge from '../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';

type Props = {
  open: boolean,
  handleClose: () => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 400,
  },
  title: {
    fontSize: '1.375rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  description: {
    margin: theme.spacing(2),
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  img: {
    maxWidth: '100%',
  },
}));

export default function StateChangeInfoModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        {useIsFeatureInTier('ORDER_STATUS_CHANGE') ? (
          <NewFeatureBadge />
        ) : (
          <PremiumFeatureBadge />
        )}
        <Typography className={classes.title} align="center">
          Cambia de estados rápidamente
        </Typography>
        <Typography className={classes.description}>
          Ahora puedes cambiar de estados rápidamente, te enseñamos cómo:
        </Typography>
        <img
          className={classes.img}
          src={quickOrderStateChangeTutorial}
          alt=""
        />
      </div>
    </CustomModal>
  );
}

StateChangeInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
